export const actionTypes = {
  EXPERT_REGISTER_REQUEST: 'EXPERT_REGISTER_REQUEST',
  EXPERT_REGISTER_SUCCESS: 'EXPERT_REGISTER_SUCCESS',
  EXPERT_REGISTER_FAILURE: 'EXPERT_REGISTER_FAILURE',
};
